import airShipmentLaneIcon from "../../images/AirShipmentLaneIcon.png";

/** Air shipment lane icon (plane + cargo) for board column headers. */
export function Plane({ size = 22, className }) {
  return (
    <img
      src={airShipmentLaneIcon}
      className={className}
      width={size}
      height={size}
      alt=""
      aria-hidden
    />
  );
}
